import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';

import { SettingsService} from './../sys/settings.service';
import { CacheService} from './../sys/cache.service';
import { WindowService } from './window.service';

@Injectable()
export class LinkService {
  
    filename: string;
    
    constructor(private windowService: WindowService,
                private settingsService: SettingsService,
                private cacheService: CacheService){
    }
    
    evaluateAnchorTagText(text) : Array<string> {
      return this.evaluateLinkText(text);
    }
  
    evaluateLinkTagText(text) : Array<string> {
      return this.evaluateLinkText(text, '<link>', '</link>');
    }
    
    /*
     * Splits text with imbedded anchor links into a three piece array
     */
    evaluateLinkText(text: string, anchorStart: string = '<a>', anchorEnd: string = '</a>') : Array<string> {
        
        let startIndex : number = text.indexOf(anchorStart);
        let endIndex : number = text.indexOf(anchorEnd);
        let preLinkText : string = text.slice(0, startIndex);
        let linkText : string = text.slice(startIndex + anchorStart.length, endIndex);
        let postLinkText : string = text.slice(endIndex + anchorEnd.length);
        
        let textArray = new Array<string>();
        textArray.push(preLinkText);
        textArray.push(linkText);
        textArray.push(postLinkText);
      
        return textArray;
    }

    goExternalLink(key) {
      this.windowService.openExternalWindow(this.getExternalLink(key));
    };
      
    getExternalLink(key: string): string{
        // if the external link help param is present replace it with the url
     //   return this.cacheService.getExternalLink(key);
        return "";
    }
	
  	openExternalSameWindow(key) {
  		window.location.href = this.getExternalLink(key);
  	}
    
    getRelativeExternalLink(key) {
    //  window.location.href = this.cacheService.getExternalLink(key);
    }
};